import type { SymbolRenderProps } from '../types';

const TIP_HEIGHT = 2;
const SHAFT_WIDTH = 0.4;

export function ArrowRetrosynthetic({ shaftLength }: SymbolRenderProps) {
  const halfShaft = shaftLength / 2;

  return (
    <g>
      <line
        x1={-halfShaft} y1={0}
        x2={halfShaft} y2={0}
        stroke="black" strokeWidth={SHAFT_WIDTH}
      />
      {/* Double open arrowhead (two chevrons) */}
      <polyline
        points={`${halfShaft - 3},${-TIP_HEIGHT} ${halfShaft},0 ${halfShaft - 3},${TIP_HEIGHT}`}
        fill="none" stroke="black" strokeWidth={SHAFT_WIDTH}
      />
      <polyline
        points={`${halfShaft - 4.5},${-TIP_HEIGHT} ${halfShaft - 1.5},0 ${halfShaft - 4.5},${TIP_HEIGHT}`}
        fill="none" stroke="black" strokeWidth={SHAFT_WIDTH}
      />
    </g>
  );
}
